"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../icons/FontAwesome");
var TableMenuIsDeprecated = /** @class */ (function (_super) {
    __extends(TableMenuIsDeprecated, _super);
    function TableMenuIsDeprecated(props) {
        var _this = _super.call(this, props) || this;
        _this.action_deprecate_true = "deprecate:true";
        _this.action_deprecate_false = "deprecate:false";
        return _this;
    }
    TableMenuIsDeprecated.prototype.doDeprecatedAction = function (e, RecordKey, RecordTitle) {
        var _deprecate = false;
        if (e.key == this.action_deprecate_true) {
            _deprecate = true;
        }
        if (this.props.onDeprecateClick) {
            this.props.onDeprecateClick(RecordKey, RecordTitle, _deprecate);
        }
    };
    TableMenuIsDeprecated.prototype.getDropDownLink = function (record) {
        if (record.deprecated) {
            return (React.createElement("a", { className: "ant-dropdown-link", style: { color: "#FF0000" }, href: "#" },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "eye-slash" }),
                " ",
                this.props.deprecatedTexts.text,
                " ",
                React.createElement(FontAwesome_1.FA, { right: true, icon: "chevron-down" })));
        }
        else {
            return (React.createElement("a", { className: "ant-dropdown-link", href: "#" },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "eye" }),
                " ",
                this.props.notDeprecatedTexts.text,
                " ",
                React.createElement(FontAwesome_1.FA, { right: true, icon: "chevron-down" })));
        }
    };
    TableMenuIsDeprecated.prototype.getIsDeprecatedDropDownMenu = function (record) {
        var _this = this;
        return (React.createElement(antd_1.Menu, { onClick: function (e) { _this.doDeprecatedAction(e, record.key, record.title); } },
            React.createElement(antd_1.Menu.Item, { key: this.action_deprecate_false, disabled: !record.deprecated },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "eye" }),
                this.props.notDeprecatedTexts.menu),
            React.createElement(antd_1.Menu.Divider, null),
            React.createElement(antd_1.Menu.Item, { key: this.action_deprecate_true, disabled: record.deprecated },
                React.createElement(FontAwesome_1.FA, { left: true, icon: "eye-slash" }),
                this.props.deprecatedTexts.menu)));
    };
    TableMenuIsDeprecated.prototype.render = function () {
        return (React.createElement(antd_1.Dropdown, { overlay: this.getIsDeprecatedDropDownMenu(this.props.record), trigger: ['click'] }, this.getDropDownLink(this.props.record)));
    };
    return TableMenuIsDeprecated;
}(React.Component));
exports.default = TableMenuIsDeprecated;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/table_menus/TableMenuIsDeprecated.tsx
// module id = 55
// module chunks = 0